var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Facebook_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48 0H0v48h48z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24c0 11.979 8.776 21.908 20.25 23.708v-16.77h-6.094V24h6.094v-5.288c0-6.014 3.583-9.337 9.065-9.337 2.626 0 5.372.469 5.372.469v5.906h-3.026c-2.981 0-3.911 1.85-3.911 3.748V24h6.656l-1.064 6.938H27.75v16.77C39.224 45.908 48 35.98 48 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.342 30.938 34.406 24H27.75v-4.502c0-1.898.93-3.748 3.911-3.748h3.026V9.844s-2.746-.469-5.372-.469c-5.482 0-9.065 3.322-9.065 9.337V24h-6.094v6.938h6.094v16.77a24.2 24.2 0 0 0 7.5 0v-16.77z"
  }))));
};
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIGZpbGw9Im5vbmUiPjxtYXNrIGlkPSJhIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHg9IjAiIHk9IjAiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNDggMEgwdjQ4aDQ4VjBaIi8+PC9tYXNrPjxnIG1hc2s9InVybCgjYSkiPjxwYXRoIGZpbGw9IiMxODc3RjIiIGQ9Ik00OCAyNEM0OCAxMC43NDUgMzcuMjU1IDAgMjQgMFMwIDEwLjc0NSAwIDI0YzAgMTEuOTc5IDguNzc2IDIxLjkwOCAyMC4yNSAyMy43MDh2LTE2Ljc3aC02LjA5NFYyNGg2LjA5NHYtNS4yODhjMC02LjAxNCAzLjU4My05LjMzNyA5LjA2NS05LjMzNyAyLjYyNiAwIDUuMzcyLjQ2OSA1LjM3Mi40Njl2NS45MDZoLTMuMDI2Yy0yLjk4MSAwLTMuOTExIDEuODUtMy45MTEgMy43NDhWMjRoNi42NTZsLTEuMDY0IDYuOTM4SDI3Ljc1djE2Ljc3QzM5LjIyNCA0NS45MDggNDggMzUuOTggNDggMjRaIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTMzLjM0MiAzMC45MzggMzQuNDA2IDI0SDI3Ljc1di00LjUwMmMwLTEuODk4LjkzLTMuNzQ4IDMuOTExLTMuNzQ4aDMuMDI2VjkuODQ0cy0yLjc0Ni0uNDY5LTUuMzcyLS40NjljLTUuNDgyIDAtOS4wNjUgMy4zMjItOS4wNjUgOS4zMzdWMjRoLTYuMDk0djYuOTM4aDYuMDk0djE2Ljc3YTI0LjE3IDI0LjE3IDAgMCAwIDcuNSAwdi0xNi43N2g1LjU5MloiLz48L2c+PC9zdmc+";